<template>
    <div>
        <hr />
        <settings-property :label="resource('JourneyComposer_BrickSettingsAudienceFilter_ConditionName_DisplayName')">
            <template #input="{id}">
                <input-group icon="far fa-edit">
                    <input
                        type="text"
                        class="form-control"
                        :id="id"
                        v-model="nameModel"

                        :disabled="!canWrite"
                    />
                </input-group>
            </template>
        </settings-property>

        <settings-property :label="resource('JourneyComposer_BrickSettingsAudienceFilter_ConditionColor_DisplayName')">
            <template #input >
                <color-picker @change-color="colorModel = $event" :color="colorModel" :last-color="lastColor" :enabled="canWrite" />
            </template>
        </settings-property>

        <settings-property :label="resource('JourneyComposer_BrickSettingsAudienceFilter_ConditionFields_DisplayName')">
            <template #input>
                <id-dispenser :elements="fieldsModel">
                    <template v-slot="{ idsPerElement }">
                        <template v-for="(field, index) in fieldsModel">
                            <div :key="idsPerElement.get(field)">
                                <audience-filter-brick-condition-field
                                    :fields="fieldTypes"
                                    :value.sync="field.value"
                                    :type.sync="field.type"

                                    @delete="deleteFieldAt(index)"
                                />
                            </div>
                        </template>
                    </template>
                </id-dispenser>
            </template>
        </settings-property>

        <div class="row">
            <div class="col-4"></div> 
            <div class="col-8">
                <button class="btn btn-outline-secondary" @click="addField" :disabled="!canWrite">
                    <i class="fas fa-plus"></i> {{resource('JourneyComposer_BrickSettingsAudienceFilter_AddField_DisplayName')}}
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-8">
            </div>
            <div class="col-4">
                <button class="btn btn-outline-danger btn-icon-left w-100" @click="$emit('delete')" :disabled="!canWrite">
                    <i class="fa fa-trash"></i> {{resource('JourneyComposer_BrickSettingsAudienceFilter_RemoveCondition_DisplayName')}}
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    import api from "@modules/JourneyBuilder/api";
    import {bootstrapDangerGrowl as errorGrowl} from "@core/Util/growler";

    import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';
    import resourceMixin from "@core/Util/Mixins/resources";
    
    import IdDispenser from "@core/Components/Util/IdDispenser.vue";
    import ColorPicker from "@core/Components/Util/ColorPicker.vue";
    import SettingsProperty from "../SettingsProperty";
    import AudienceFilterBrickConditionField from "./AudienceFilterBrickConditionField.vue";
    import InputGroup from '@core/Components/Inputs/InputGroup.vue';

    export default {
        name: 'audience-filter-brick-condition',
        mixins: [permissionsMixin, resourceMixin],
        components: {
            ColorPicker,
            SettingsProperty,
            AudienceFilterBrickConditionField,
            IdDispenser,
            InputGroup
        },
        created() {
            const vm = this;
            
            //Create a complete copy of our fields array
            vm.fieldsModel = vm.fields.map(({type, value}) => ({type, value}));

            api.getAudienceFilterFieldTypes().then(
                fieldTypes => vm.fieldTypes = fieldTypes,
                err => errorGrowl(err)
            );
            
            // api.getAllAudiences().then((audiences) => { 
            //         vm.audiences = audiences 
            //     }, errorGrowl
            // )
        },
        methods: {
            addField(){
                this.fieldsModel.push({
                    type: null,
                    value: null 
                });
            },
            deleteFieldAt(index){
                this.fieldsModel.splice(index, 1);
            }
        },
        watch: {
            colorModel(_, previousValue){
                this.lastColor = previousValue;
            },
            fieldsModel: {
                handler(value){
                    this.$emit('update:fields', value);
                },
                deep: true
            }
        },
        computed: {
            nameModel: {
                get(){
                    return this.name;
                },
                set(value){
                    this.$emit('update:name', value);
                }
            },
            colorModel: {
                get(){
                    return this.color;
                },
                set(value){
                    this.$emit('update:color', value);
                }
            }
        },
        data: () => ({
            lastColor: null,
            fieldsModel: [],
            fieldTypes: [],
            //audiences: []
        }),
        props: {
            name: String,
            color: String,
            fields: Array
        }
    }
</script>